var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamRound = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.5,
  cy: 8.5,
  r: 8.5,
  fill: "#FA4F38"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.792 10.584H8.968L9.626 4.144V3.808H7.134V4.144L7.792 10.584ZM7.246 14H9.514V11.732H7.246V14Z",
  fill: "white"
})));
export default SvgExclamRound;